import Map from 'scripts/models/base/map';

export default Map.extend({
    define: {
        type: {
            type: 'string',
            value: 'html'
        },
        html: {
            type: 'string',
            value: '' // required
        }
    }
});